// Node
import noUiSlider from "nouislider";

export default class DistanceRange extends React.Component {
  constructor (props) {
    super(props);
    this.interacted = false;
    this.slider = null;
    this.distance = this.props.value || this.props.default_distance;
    this.interaction = this.interaction.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    if (location.href.includes('#map_opened')) {
      this.interaction();
    }
  }

  componentDidMount() {
    // Создаем слайдер.
    // min и max должны отличаться
    this.slider = noUiSlider.create(document.getElementById(`${this.props.filterValue}Slider`), {
      start: this.distance,
      connect: [true, false],
      animation: true,
      range: {
        'min': 5,
        'max': this.props.max_distance || 1
      }
    });

    let component = this;
    // Обновляем
    // инпут только во время перетягивания слайдера.
    this.slider.on('update', function (values, handle) {
      let value = Math.round(values[handle]);

      document.getElementById(`${component.props.filterValue}SliderVal`).value = value;
    });

    // Сортируем базы и запоминаем растояние, когда слайдер остановился.
    this.slider.on('change', function (values, handle) {
      // Если выбран город, это подгрузит еще и ОР области (логика Совы).
      if (!component.interacted) {
        component.interaction();
      }
      window.ymReachGoal('filter:slider:sliderChange');

      let value = Math.round(values[handle]);
      component.props.filter(component.props.filterValue, value);
    });
  }

  shouldComponentUpdate(nextProps) {
    return this.props.value != nextProps.value;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value != nextProps.value) {
      this.slider.set(nextProps.value);
    }
  }

  // Взаимодействовали со слайдером
  interaction() {
    if (this.props.distanceInteraction != null) {
      this.props.distanceInteraction();
    }
    this.interacted = true;
  }

  // После ввода значения в инпут сохраняем его, перетаскиваем слайдер и сортируем базы.
  handleInputChange(event) {
    let value = event.target.value;

    window.ymReachGoal('filter:slider:inputChange');
    this.slider.set(value);
    this.props.filter(this.props.filterValue, value);
  }

  render() {
    return (
      <div className='filter-row'>
        <div className='filter-row__title'>
          {this.props.title}
        </div>
        <div className='pick-line pick-line-one'>
          <div id={`${this.props.filterValue}Slider`}/>
          <div className='pick-input'>
            <div className='pick-input__box'>
              <input type='text'
                     className='pick-price-input-short short'
                     id={`${this.props.filterValue}SliderVal`}
                     defaultValue={this.distance}
                     onChange={this.handleInputChange}
              />
              <span className='pick-input__box-currency'>км</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
